import type { Permission, Role } from '@/types';

import { useCurrentBusiness } from './use-current-business';

/**
 * Role/permission surface for the active business, wrapping
 * `useCurrentBusiness()`. Replaces the scattered `business?.role === 'owner'`
 * comparisons that used to live in each component.
 */
export function useRole() {
  const business = useCurrentBusiness();
  const role: Role | null = business?.role ?? null;

  return {
    role,
    isOwner: role === 'owner',
    isEmployee: role === 'employee',
    hasPermission: (permission: Permission) =>
      Boolean(business?.permissions?.includes(permission)),
  };
}
